import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { StudentService } from '../../../shared-components/student/student.service';

@AutoUnsubscribe({includeArrays: true})
@Component({
    selector: 'app-daily-attendance',
    templateUrl: './daily-attendance.component.html'
})
export class DailyAttendanceComponent implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];
    dataSource: TylerMatTableDataSource;
    columnsToDisplay: string[] = ['Date', 'Absent Count', 'Code'];
    @ViewChild(MatSort) sort: MatSort;

    constructor(
        private studentService: StudentService
    ) { }

    ngOnInit() {
        this.getAttendance();
        this.subscriptions.push(this.studentService.selectedStudentStream$.subscribe(student => {
            this.getAttendance();
        }));

    }

    ngOnDestroy() {}

    getAttendance() {
        this.studentService.getStudentDailyAttendance(this.studentService.studentEnrollment.SiteYearId, this.studentService.selectedStudent.Id).subscribe((dailyAttendance) => {
            this.dataSource = new TylerMatTableDataSource()
            this.dataSource.data = dailyAttendance;
            this.dataSource.sort = this.sort;
        });
    }

}